import React from "react";
import { useQuery } from 'react-query';
import {
    findMemberByPfNumber
} from "../../../api/apiServices";
import PdfStatementList from './PdfStatementList'
import downloadPdfStatement from '../../../services/downloadPdfStatement'

const MemberStatement = ({ member }) => {
    const pfNumber = member.pfNumber

    const {
        data: statement
    } = useQuery(['statement', pfNumber], () => findMemberByPfNumber(pfNumber));

    return (
        <>
            <section className="content-header">
                <h1>Member Statement</h1>
            </section>
            <section className="content">
                <div className="box">
                    <div className="box-body">
                        <div className="panel panel-default panel-br-4">
                            <div className="panel-heading">
                                <div className="row">
                                    <div className="col-sm-12">
                                        <h4 className="panel-title">
                                            <span>
                                                <button
                                                    className="btn btn-success"
                                                    onClick={() => downloadPdfStatement(statement)}
                                                >
                                                    Download PDF Statement
                                                </button>
                                            </span>
                                        </h4>
                                    </div>
                                </div>
                            </div>
                            <div className="panel-body">
                                {statement ?
                                    <PdfStatementList member={statement} />
                                    : null
                                }
                            </div>
                            <div className="panel-footer">
                            </div>
                        </div>
                        <div className="box-footer"></div>
                    </div>
                </div>
            </section>
        </>

    );
};

export default MemberStatement;